/** Keep the windows aligned with `backend/apps/amministrazione/src/appuntamento.rules.ts`. */
export const DURATE_MINUTI = [15, 30, 45, 60, 90, 120, 180, 240] as const;
export type DurataMinuti = (typeof DURATE_MINUTI)[number];
export const DURATA_DEFAULT: DurataMinuti = 60;

export const DURATA_OPTIONS: { value: DurataMinuti; label: string }[] = [
  { value: 15, label: '15 minuti' },
  { value: 30, label: '30 minuti' },
  { value: 45, label: '45 minuti' },
  { value: 60, label: '1 ora' },
  { value: 90, label: '1 ora e 30 minuti' },
  { value: 120, label: '2 ore' },
  { value: 180, label: '3 ore' },
  { value: 240, label: '4 ore' },
];

export function durationLabel(minutes: number): string {
  return DURATA_OPTIONS.find((option) => option.value === minutes)?.label ?? `${minutes} minuti`;
}

export function normalizeDurata(value: number | null | undefined): DurataMinuti {
  if (typeof value === 'number' && (DURATE_MINUTI as readonly number[]).includes(value)) return value as DurataMinuti;
  return DURATA_DEFAULT;
}

export const PROMEMORIA_MINUTI = [30, 1] as const;
export type PromemoriaMinuti = (typeof PROMEMORIA_MINUTI)[number];

const MINUTE = 60_000;

export function promemoriaDovuti(now: Date, iniziaAt: Date): PromemoriaMinuti[] {
  const start = iniziaAt.getTime();
  const at = now.getTime();
  if (Number.isNaN(start) || Number.isNaN(at) || at >= start) return [];
  const due: PromemoriaMinuti[] = [];
  const at30 = start - 30 * MINUTE;
  const at1 = start - MINUTE;
  if (at >= at30 && at < at1) due.push(30);
  if (at >= at1) due.push(1);
  return due;
}

export function promemoriaCanaliLabel(
  rows: readonly { minuti: number; canale: string }[],
  minuti: PromemoriaMinuti,
): string {
  const sent = rows.filter((row) => row.minuti === minuti);
  if (sent.length === 0) return 'in attesa';
  const hasInbox = sent.some((row) => row.canale === 'in_app');
  const hasMail = sent.some((row) => row.canale === 'email');
  if (hasInbox && hasMail) return 'notifica e mail inviate';
  if (hasMail) return 'mail inviata';
  return 'notifica inviata';
}
